export default function beforeSuperAdminAuth({ next, router }) {
    if (localStorage.getItem('super_admin_token')) {
        return router.push({ path: 'admin-dashboard' });
    }
    return next();
  }